var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8433 -0.0256239L14.8433 -0.0256229L0.564119 4.73415C-0.307705 5.02473 -0.280684 6.26712 0.602888 6.51953L7.50757 8.49239L9.48034 15.3971C9.73284 16.2807 10.9751 16.3078 11.2657 15.4358L16.0255 1.1567L15.9543 1.13298L16.0255 1.1567C16.269 0.426028 15.574 -0.269154 14.8433 -0.0256239ZM8.48292 8.23092L14.6632 2.05069L10.3846 14.8866L8.48292 8.23092ZM1.11343 5.61536L13.9493 1.33672L7.76904 7.51695L1.11343 5.61536Z",
    fill: "#075E45",
    stroke: "#075E45",
    strokeWidth: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_1445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.fd04739c59eba67687813241a90e5561.svg";
export { ForwardRef as ReactComponent };